module.exports = __webpack_public_path__ + "static/media/team_jean.5a3b58f0.jpeg";